import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteClaim } from '@/services/claims';

export function useDeleteClaim() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (claimId: string) => deleteClaim(claimId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      void queryClient.invalidateQueries({ queryKey: ['claims'] });
    },
  });

  return {
    cancel: mutation.mutateAsync,
    cancelSync: mutation.mutate,
    isPending: mutation.isPending,
    loading: mutation.isPending,
    error: mutation.error?.message ?? null,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
